export const GET_PLATFORM_USERS = "GET_PLATFORM_USERS";
export const GET_PLATFORM_USERS_SUCCESS = "GET_PLATFORM_USERS_SUCCESS";

export const RESTRICT_PLATFORM_USER = "RESTRICT_PLATFORM_USER";
export const UNRESTRICT_PLATFORM_USER = "UNRESTRICT_PLATFORM_USER";

export const getPlatformUsers = () => ({
  type: GET_PLATFORM_USERS,
});

export const getPlatformUsersSuccess = users => ({
  type: GET_PLATFORM_USERS_SUCCESS,
  payload: users,
});

export const restrictPlatformUser = data => ({
  type: RESTRICT_PLATFORM_USER,
  payload: data,
});

export const unrestrictPlatformUser = data => ({
  type: UNRESTRICT_PLATFORM_USER,
  payload: data,
});
